
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/author/[authorSlug]/page/[page]",
      function () {
        return require("private-next-pages/news/author/[authorSlug]/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/author/[authorSlug]/page/[page]"])
      });
    }
  